import { PieChartGetPatientsByEpilecticSeizure } from "../PieChartGetPatientsByEpilecticSeizure";
import { BarChartGetAdherencesByPatient } from "../BarChartGetAdherencesByPatient";
import { HeatMapGetTrackingMoodByPatient } from "../HeatMapGetTrackingMoodByPatient";
import { PieChartGetAdverseEventsByEvent } from "../PieChartGetAdverseEventsByEvent";
import { PieChartGetCumulativeSurveysByMood } from "../PieChartGetCumulativeSurveysByMood";
import { PieChartGetTherapyAdherence } from "../PieChartGetTherapyAdherence";
import { role } from "../../helpers/Constants";
import { LineChartGetGroupEventiAvversi } from "../LineChartGetGroupEventiAvversi";

function Monitoring(props) {
  const user = JSON.parse(localStorage.getItem("role"));
  const isCareManger = user.idRole === role.CAREMANAGER ? true : false;
  const isAngelini = user.idRole === role.ADMIN ? true : false;
  const isDoctor = user.idRole === role.DOCTOR ? true : false;

  return (
    <>
      <div
        className="row h-100 justify-content-center align-items-center"
        style={{ width: "100%" }}
      >
        <div className="col-12">
          <div className="box">
            <div className="row">
              <div className="col-12 col-md-6 mb-2">
                <div className="container-fluid g-0">
                  {isDoctor ? (
                    <div>
                      <h2>N. pazienti / N. crisi epilettiche</h2>
                      <PieChartGetPatientsByEpilecticSeizure
                        data={props.dataGetPatientsByEpilecticSeizure}
                        commonProperties={props.commonProperties}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {isAngelini || isCareManger ? (
                    <div>
                      <h2>Aderenza terapia anticrisi</h2>
                      <PieChartGetTherapyAdherence
                        data={props.dataGetTherapyAdherence}
                        commonProperties={props.commonProperties}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="col-12 col-md-6 mb-2">
                {/* <div className="container-fluid g-0">
                                    <div >
                                        <h2>Eventi avversi</h2>
                                        <PieChartGetAdverseEventsByEvent data={props.dataGetAdverseEventsByEvent} commonProperties={props.commonProperties} />
                                    </div>
                                </div> */}
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <h2>Eventi avversi</h2>
                <LineChartGetGroupEventiAvversi
                  data={props.dataGetGroupEventiAvversi}
                  commonProperties={props.commonProperties}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export { Monitoring };
